module.exports = __webpack_public_path__ + "img/logoadeConnect-light.efc53ed1.png";